// extracted by mini-css-extract-plugin
export default {"wrapper":"GiRAt","container":"FGzVh","isCentered":"tDStR","alwaysLtr":"eQAN4","alwaysHorizontal":"_19JCA","buttonWrapper":"t-o+s","button":"_9ARA-"};